'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _IconButton = require('@material-ui/core/IconButton');
var _IconButton2 = _interopRequireDefault(_IconButton);
var _colorManipulator = require('@material-ui/core/styles/colorManipulator');
var _reactRouter = require('react-router');
var _reactRouterDom = require('react-router-dom');
var _logoEventtia = require('../../assets/logo-eventtia');
var _logoEventtia2 = _interopRequireDefault(_logoEventtia);
var _xTwitter = require('../../assets/icons/x-twitter.svg');
var _xTwitter2 = _interopRequireDefault(_xTwitter);
var _pages = require('../../helpers/pages');
var _ResponsiveModes = require('../../constants/ResponsiveModes');
var _redux = require('redux');
var _withGlobalSettings = require('../../hocs/withGlobalSettings');
var _withGlobalSettings2 = _interopRequireDefault(_withGlobalSettings);
var _misc = require('../../helpers/misc');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  FooterWrapper: {
    padding: function padding(_ref) {
      var responsiveMode = _ref.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP && '0 1rem';
    },
    backgroundColor: function backgroundColor(_ref2) {
      var _backgroundColor = _ref2.cssProperties.backgroundColor;
      return _backgroundColor;
    }
  },
  footerInnerWrapper: {
    margin: 'auto',
    display: 'flex',
    flexWrap: 'no-wrap',
    maxWidth: function maxWidth(_ref3) {
      var siteMaxWidth = _ref3.siteMaxWidth;
      return !!siteMaxWidth && siteMaxWidth;
    },
    width: '100%',
    alignItems: 'flex-start',
    flexDirection: function flexDirection(_ref4) {
      var responsiveMode = _ref4.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? 'row' : 'column';
    },
    justifyContent: 'space-between',
    '& .footer-items': {
      display: 'flex',
      flexWrap: 'wrap',
      listStyle: 'none',
      padding: '0rem 1rem 1rem 2rem',
      flexDirection: function flexDirection(_ref5) {
        var responsiveMode = _ref5.responsiveMode;
        return responsiveMode === _ResponsiveModes.DESKTOP ? 'row' : 'column';
      },
      marginTop: '0',
      '& li': {
        margin: function margin(_ref6) {
          var responsiveMode = _ref6.responsiveMode;
          return responsiveMode === _ResponsiveModes.DESKTOP ? '1rem' : '0.2rem 1rem 1rem 0.2rem';
        },
        padding: function padding(_ref7) {
          var responsiveMode = _ref7.responsiveMode;
          return responsiveMode === _ResponsiveModes.DESKTOP ? '0rem' : '0.1rem 1rem 1rem 0.1rem';
        }
      }
    },
    '& .footer-item': {
      boxSizing: 'border-box',
      color: 'inherit',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      fontFamily: 'inherit'
    },
    '& .logo-wrapper': {
      display: 'block',
      minWidth: '35%',
      '& .logo-inner-wrapper': {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        padding: function padding(_ref8) {
          var responsiveMode = _ref8.responsiveMode,
            socialMediaIconSize = _ref8.otherProperties.socialMediaIconSize;
          return responsiveMode === _ResponsiveModes.DESKTOP ? '0rem' : '1rem 2rem ' + socialMediaIconSize + ' 2rem';
        }
      }
    }
  },
  logo: {
    objectFit: 'contain',
    alignSelf: 'center',
    width: 'auto',
    maxWidth: '11rem',
    maxHeight: '6rem'
  },
  socialMedia: {
    display: 'flex',
    justifyContent: 'flex-start',
    fontSize: function fontSize(_ref9) {
      var socialMediaIconSize = _ref9.otherProperties.socialMediaIconSize;
      return socialMediaIconSize;
    },
    padding: function padding(_ref10) {
      var responsiveMode = _ref10.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '0.7rem 0rem' : '0rem 2rem 2rem 2rem';
    },
    '& a': {
      color: function color(_ref11) {
        var socialMediaIconColor = _ref11.otherProperties.socialMediaIconColor;
        return socialMediaIconColor;
      },
      display: 'inline-flex',
      textDecoration: 'none',
      alignSelf: 'center',
      margin: '0 0 0 1rem',
      '&:first-of-type': {
        margin: 0
      }
    },
    '& svg': {
      fill: 'currentColor',
      width: function width(_ref12) {
        var socialMediaIconSize = _ref12.otherProperties.socialMediaIconSize;
        return socialMediaIconSize;
      },
      height: function height(_ref13) {
        var socialMediaIconSize = _ref13.otherProperties.socialMediaIconSize;
        return socialMediaIconSize;
      },
      display: 'block'
    }
  },
  rightSide: {
    minWidth: function minWidth(_ref14) {
      var responsiveMode = _ref14.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '100%' : '60%';
    }
  }
};
var SimpleFooter = function (_Component) {
  _inherits(SimpleFooter, _Component);
  function SimpleFooter() {
    var _ref15;
    var _temp, _this, _ret;
    _classCallCheck(this, SimpleFooter);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref15 = SimpleFooter.__proto__ || Object.getPrototypeOf(SimpleFooter)).call.apply(_ref15, [this].concat(args))), _this), _this.renderItems = function (items) {
      var otherProperties = _this.props.otherProperties;
      var linkSelector = otherProperties.linkSelector;
      return _react2.default.createElement('ul', {
        className: 'footer-items'
      }, items.filter(function (item) {
        return !item.hideFromFooter;
      }).map(function (item) {
        return _react2.default.createElement('li', {
          key: item.id
        }, _react2.default.createElement(_reactRouterDom.Link, {
          to: _this.getUrl(item),
          className: 'footer-item'
        }, item.name));
      }), !!linkSelector && !!linkSelector.length && linkSelector.map(function (extra_item) {
        return _react2.default.createElement('li', {
          key: extra_item.text
        }, _react2.default.createElement('a', {
          href: extra_item.link,
          target: extra_item.newTab == true ? '_blank' : '_self',
          className: 'footer-item'
        }, extra_item.text));
      }));
    }, _this.getUrl = function (page) {
      var _this$props = _this.props,
        match = _this$props.match,
        location = _this$props.location;
      var pathParts = match.path.split('/');
      var urlParts = match.url.split('/');
      var indexOfPage = pathParts.indexOf(':page?');
      if (indexOfPage === -1 || urlParts.length < pathParts.length) return (0, _misc.appendSlashIfNeeded)(match.url) + (0, _pages.getPageUrl)(page) + (location.search || '');
      urlParts.splice(indexOfPage, 1, (0, _pages.getPageUrl)(page));
      return (0, _misc.appendSlashIfNeeded)(urlParts.join('/')) + (location.search || '');
    }, _this.renderSocialMedia = function (className, _ref16) {
      var facebookLink = _ref16.facebookLink,
        twitterLink = _ref16.twitterLink,
        linkedInLink = _ref16.linkedInLink,
        instagramLink = _ref16.instagramLink,
        youTubeLink = _ref16.youTubeLink;
      return _react2.default.createElement('div', {
        className: className
      }, facebookLink && _react2.default.createElement('a', {
        href: (0, _misc.prependHttpIfNeeded)(facebookLink),
        target: '_blank'
      }, _react2.default.createElement('i', {
        className: 'fa fa-facebook-square'
      })), twitterLink && _react2.default.createElement('a', {
        href: (0, _misc.prependHttpIfNeeded)(twitterLink),
        target: '_blank'
      }, _react2.default.createElement('svg', {
        fill: 'currentColor'
      }, _react2.default.createElement('use', {
        href: _xTwitter2.default + '#x-twitter-logo'
      }))), linkedInLink && _react2.default.createElement('a', {
        href: (0, _misc.prependHttpIfNeeded)(linkedInLink),
        target: '_blank'
      }, _react2.default.createElement('i', {
        className: 'fa fa-linkedin-square'
      })), instagramLink && _react2.default.createElement('a', {
        href: (0, _misc.prependHttpIfNeeded)(instagramLink),
        target: '_blank'
      }, _react2.default.createElement('i', {
        className: 'fa fa-instagram'
      })), youTubeLink && _react2.default.createElement('a', {
        href: (0, _misc.prependHttpIfNeeded)(youTubeLink),
        target: '_blank'
      }, _react2.default.createElement('i', {
        className: 'fa fa-youtube-play'
      })));
    }, _this.getLogo = function (className) {
      var _this$props2 = _this.props,
        classes = _this$props2.classes,
        entities = _this$props2.entities,
        otherProperties = _this$props2.otherProperties;
      var logoSrc = otherProperties.logoSrc,
        socialMedia = otherProperties.socialMedia;
      var event = entities[Object.keys(entities)[0]];
      return _react2.default.createElement('div', {
        className: 'logo-wrapper'
      }, _react2.default.createElement('div', {
        className: 'logo-inner-wrapper'
      }, logoSrc || event.logo.filename ? _react2.default.createElement('img', {
        className: className,
        src: logoSrc || event.logo.medium,
        alt: 'event logo'
      }) : _react2.default.createElement(_logoEventtia2.default, {
        className: className,
        style: {
          fill: 'currentColor',
          width: '9rem'
        }
      })), socialMedia && _this.renderSocialMedia(classes.socialMedia, otherProperties));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(SimpleFooter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        cssProperties = _props.cssProperties,
        otherProperties = _props.otherProperties,
        pages = _props.pages,
        responsiveMode = _props.responsiveMode,
        editable = _props.editable,
        value = _props.value,
        onChangeText = _props.onChangeText,
        siteMaxWidth = _props.siteMaxWidth;
      var logoPosition = otherProperties.logoPosition,
        socialMedia = otherProperties.socialMedia;
      return _react2.default.createElement('div', {
        className: classes.FooterWrapper
      }, _react2.default.createElement('footer', {
        className: classes.Footer,
        style: cssProperties
      }, _react2.default.createElement('div', {
        className: classes.footerInnerWrapper
      }, this.getLogo(classes.logo), _react2.default.createElement('div', {
        className: classes.rightSide
      }, this.renderItems(pages)))));
    }
  }]);
  return SimpleFooter;
}(_react.Component);
var enhance = (0, _redux.compose)(_withGlobalSettings2.default, _reactRouter.withRouter, (0, _reactJss2.default)(styles));
exports.default = enhance(SimpleFooter);